/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */





(function($) {

	var Viewport = {};

	Viewport.documentWidth = function(){
	    var e = window, a = 'inner';
	    if (!('innerWidth' in window )) {
	        a = 'client';
	        e = document.documentElement || document.body;
	    }
	    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};


	var sliderUI = {};
	sliderUI.slideClick = function () {
		var switchSlider = $('#myonoffswitch');
		$('.ja').on( 'click', function() {
			switchSlider.prop('checked', true);
		});
		$('.nej').on( 'click', function() {
			switchSlider.prop('checked', false);
		});
	};

	var Navigation = {};

	Navigation.effectHover = function() {
		if ($(".navbar-nav").length > 0){
			var $el, leftPos, newWidth,
				$mainNav = $(".navbar-nav");
			
			$mainNav.append("<li id='nav-active'></li>");
			var $magicLine = $("#nav-active");

			if ($(".navbar-nav .current_page_item").length > 0){
				$magicLine
					.width($(".current_page_item").width())
					.css("left", $(".current_page_item").position().left)
					.data("origLeft", $magicLine.position().left)
					.data("origWidth", $magicLine.width());		
			}
			else {
				$magicLine
					.width(0)
					.css("left", $("li:first-child").position().left)
					.data("origLeft", $magicLine.position().left)
					.data("origWidth", $magicLine.width());
			}
				
			$(".navbar-nav li a").hover(function() {
				
				$el = $(this);
				leftPos =  $el.parent().position().left;
				newWidth = $el.parent().width();

				$magicLine.stop().animate({
					left: leftPos,
					width: newWidth
				});
			}, function() {
				$magicLine.stop().animate({
					left: $magicLine.data("origLeft"),
					width: $magicLine.data("origWidth")
				});    
			});
		}
	};
	
	Navigation.navFooter = function() {
		var getFooter = $('.footer-list').html();
		$(".navbar-collapse").append("<div id='nav-footer' class='visible-xs'></div>");
		$('#nav-footer').html( getFooter );
	};

	Navigation.animate = function() {
		var getScrollPos = 0;
		$('.navbar .navbar-collapse').on('shown.bs.collapse', function () {
			$(".nav-mob").addClass("selected");
			getScrollPos = $(window).scrollTop();
			$('body').addClass('lock-position');
			Navigation.navFooter();
		});

		$('.navbar .navbar-collapse').on('hide.bs.collapse', function () {
			$(".nav-mob").removeClass("selected");
			$('body').removeClass('lock-position');
			$(window).scrollTop(getScrollPos);
			$('#nav-footer').remove();
		});
		
	};
	
	var UIplugins = {};
	
	UIplugins.init = function() {
		UIplugins.selectUI();
	};
	
	UIplugins.selectUI = function() {
		$( ".slct-ui" ).selectmenu({ 
			width : '100%'
		});
	};
	
	var switchContent = {};
	
	switchContent.popOut = function() {
		if( Viewport.documentWidth().width <= 767 ) {
			if ($('.bottom-btn').length > 0 ) {
			
			}
			else {
				$( '<div class="bottom-btn"></div>' ).insertAfter( ".bottom-text" );
			}
			
			if( $('.bottom-btn').length > 0 ) {
				var blBtn = $('.footer-button').html();
				if ($('.bottom-btn').is(':empty')){
					$('.bottom-btn').html( blBtn );
					$('.footer-button').html('');
				}
				
			}
		}
		else {
			
			if ( $('.footer-button').is(':empty') ) {
				var midBtn = $('.bottom-btn').html();
				$('.footer-button').html( midBtn );
				$('.bottom-btn').html('');
			}
			
		}

	};
	
	
	$( window ).on( 'resize', function() {
		// switchContent.popOut();
	} );
	
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
		UIplugins.init();
		Navigation.effectHover();
		Navigation.animate();
		sliderUI.slideClick();
		// switchContent.popOut();
		Viewport.documentWidth();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
